import { render, staticRenderFns } from "./BienestarSocialPage.vue?vue&type=template&id=02fb8ea8"
import script from "./BienestarSocialPage.js?vue&type=script&lang=js&external"
export * from "./BienestarSocialPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports